import './client.scss';

import { Outlet } from "react-router-dom";

import { FilterQuotationProvider } from '../quotation/filter-quotation/filter-quotation.context';
import { FilterClientProvider } from "./filter-client/filter-client.context";

export function Client() {
  return (
    <div id="ShellClient" className="client">
       <FilterClientProvider>
        <FilterQuotationProvider>
          <Outlet />
        </FilterQuotationProvider>
      </FilterClientProvider>
    </div>
  );
}

export default Client;
